import { Input, Modal } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import { AccountActions } from '@store/reducers/account'
import type React from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import type { ModalProps } from '@/types'
import css from './styles.module.css'

export const DeleteAccount: React.FC<ModalProps> = ({ onClose }) => {
  const dispatch = useDispatch()

  const [canDelete, setCanDelete] = useState(false)

  const handleOnChange = (value: string) => {
    if (value.toLocaleLowerCase() === 'delete') {
      return setCanDelete(true)
    }

    setCanDelete(false)
  }

  const handleDelete = () => {
    if (canDelete) {
      dispatch(AccountActions.delete())
    }
  }

  return (
    <Modal classnames={{ content: css.modal_content }} onClose={onClose}>
      <div className={css.modal_title}>Delete my account</div>
      <div className={css.modal_description}>
        Once your account is deleted, you’ll no longer be charged, and we’ll
        make sure all of your data is securely deleted from our servers.
      </div>
      <div className={css.modal_description}>
        Confirm by typing <b>DELETE</b> below.
      </div>

      <Input
        placeholder="Type here"
        id="confirmation"
        onChange={handleOnChange}
      />

      <div className={css.modal_buttons}>
        <Button
          tone="danger"
          label="Yes"
          disabled={!canDelete}
          onClick={handleDelete}
        />

        <Button priority="secondary" label="Cancel" onClick={onClose} />
      </div>
    </Modal>
  )
}
